module.exports = __webpack_public_path__ + "static/media/sonicscale-toothbrush-head-4.a67a48fc.jpg";